import type { Dict } from "../en";

export const auto: Dict["auto"] = {
  automations: "Tự động hóa",
  automation: "Tác vụ tự động",
  newAutomation: "Tác vụ tự động mới",
  newShort: "Tạo",
  newRest: " tác vụ tự động",
  orAskInChat: "Hoặc cứ hỏi Vantage trong cuộc trò chuyện",
  searchPlaceholder: "Tìm tác vụ tự động…",
  searchLabel: "Tìm tác vụ tự động",
  kind: "Loại",
  postsTo: "Đăng vào",
  postsToChannel: "Đăng vào {channel}",
  theChannel: "kênh này",
  belongsTo: "Thuộc về",
  timed: "Theo lịch",
  triggered: "Theo sự kiện",
  reminders: "Lời nhắc",
  company: "Công ty",
  aTeam: "Một nhóm",
  mine: "Của tôi",
  listDidntLoad: "Không tải được danh sách tác vụ tự động",
  noneTitle: "Chưa có tác vụ tự động nào",
  noneBody:
    "Tác vụ tự động đăng báo cáo theo lịch, hoặc báo cho bạn khi có thay đổi trên Redmine hay GitHub.",
  noneAsk: "hoặc hỏi Vantage: “9:00 mỗi thứ Hai, đăng tiến độ tuần trước vào đây”",
  nothingMatches: "Không có kết quả phù hợp",
  showAll: "Hiện tất cả tác vụ tự động",
  when: "Thời gian",
  status: "Trạng thái",
  lastRun: "Lần chạy gần nhất",
  next: "Lần tới",
  nextWhen: "Lần tới {when}",
  openDetails: "{name}, mở chi tiết",
  count_one: "{n} tác vụ tự động",
  count_other: "{n} tác vụ tự động",
  headerLine: "{count} · {active} đang chạy · đã dùng {spent} trong hạn mức {cap} mỗi tháng",
  statusActive: "Đang chạy",
  statusPaused: "Tạm dừng",
  statusNeedsAttention: "Cần xử lý",
  statusOnHold: "Tạm giữ",
  reasonOwnerLeft: "Tạm dừng: người sở hữu đã rời nhóm mà nó đăng vào",
  reasonOwnerDeactivated: "Tạm dừng: tài khoản của người sở hữu đã bị tắt",
  reasonTeamArchived: "Tạm dừng: nhóm của nó đã được lưu trữ",
  reasonFailures: "Tạm dừng sau 3 lần chạy lỗi: {why}",
  pausedAfterFailures: "Tạm dừng sau 3 lần chạy lỗi",
  myInbox: "Hộp thư của tôi",
  myEmail: "Email của tôi",
  todayAt: "Hôm nay {time}",
  presetDaily: "Hằng ngày",
  presetWeekdays: "Thứ Hai – Thứ Sáu",
  presetWeekly: "Hằng tuần",
  presetHourly: "Hằng giờ",
  presetCustom: "Tùy chỉnh (cron)",
  monday: "Thứ Hai",
  tuesday: "Thứ Ba",
  wednesday: "Thứ Tư",
  thursday: "Thứ Năm",
  friday: "Thứ Sáu",
  saturday: "Thứ Bảy",
  sunday: "Chủ Nhật",
  evIssueCreated: "Có ticket mới",
  evStatusChanged: "Ticket chuyển sang một trạng thái",
  evAssigned: "Ticket được giao cho ai đó",
  evPrOpened: "Có PR mới",
  evPrMerged: "PR được merge",
  evReviewRequested: "Có yêu cầu review",
  evCiFailed: "CI bị lỗi",
  createdByChat: "do {name} tạo trong cuộc trò chuyện",
  createdByForm: "do {name} tạo bằng biểu mẫu",
  createdChat: "tạo trong cuộc trò chuyện",
  createdForm: "tạo bằng biểu mẫu",
  noRunsYet: "Chưa chạy lần nào",
  failedRunsLine: "{n} lần lỗi · lần cuối {time} · chưa tốn gì",
  underCentPerRun: "Dưới 1¢ mỗi lần chạy",
  aboutPerRun: "Khoảng {cost} mỗi lần chạy",
  spentSoFar: "tổng cộng {cost}",
  nothingSoFar: "chưa tốn gì",
  seconds: "{n} giây",
  minutes: "{n} phút",
  pathRecipe: "theo công thức",
  pathFull: "chạy đầy đủ",
  pathFallback: "chạy đầy đủ, công thức bị lỗi",
  skipSpendCap: "bỏ qua: tạm giữ do chạm hạn mức chi phí",
  skipAutomationsOff: "bỏ qua: tự động hóa đã bị tắt",
  skipPaused: "bỏ qua: đang tạm dừng",
  skipNeedsAttention: "bỏ qua: đang cần xử lý",
  skipDeleted: "bỏ qua: đã bị xóa",
  skipped: "bỏ qua",
  skippedWhy: "bỏ qua: {why}",
  running: "đang chạy…",
  waitingToRun: "đang chờ chạy",
  underCent: "dưới 1¢",
  runByHand: "chạy thủ công",
  failed: "lỗi",
  failedWhy: "lỗi: {why}",
  guardRails:
    "Tối đa một lần mỗi giờ · tối đa 10 tác vụ đang chạy mỗi nhóm · dừng ở mức 90% hạn mức chi phí · tạm dừng sau 3 lần chạy lỗi",
  editorsTeam: "thành viên nhóm {team} hoặc quản trị viên",
  editorsAdmin: "quản trị viên",
  ownerMe: "Tôi",
  ownerTheTeam: "Nhóm",
  theAutomation: "tác vụ tự động",
  thisAutomation: "tác vụ tự động này",
  cardGone: "Tác vụ tự động này đã bị xóa, hoặc bạn không có quyền xem.",
  activeNext: "Đang chạy · lần tới {when}",
  cardSub: "{when} · đăng vào {dest} · {runsWith}",
  view: "Xem",
  pause: "Tạm dừng",
  resume: "Chạy lại",
  pausedName: "Đã tạm dừng “{name}”.",
  onAgain: "“{name}” đã chạy lại.",
  deleteTitle: "Xóa “{name}”?",
  deleteBody: "Tác vụ sẽ dừng hẳn và không chạy thêm lần nào nữa.",
  deleteBodyChannel:
    "Tác vụ sẽ dừng hẳn và không chạy thêm lần nào nữa. {channel} sẽ được báo về việc này.",
  deletedName: "Đã xóa “{name}”.",
  viewPost: "Xem bài đăng",
  backToList: "Quay lại danh sách",
  details: "Chi tiết tác vụ tự động",
  notHere: "Không tìm thấy tác vụ tự động này",
  notHereBody: "Có thể nó đã bị xóa, hoặc bạn không có quyền xem.",
  didntLoad: "Không tải được",
  fixCause: "{reason}. Hãy khắc phục nguyên nhân rồi bật lại.",
  onHoldNote:
    "Tạm giữ: chi phí đã đạt 90% hạn mức, nên các tác vụ tự động sẽ chờ đến khi chi phí giảm xuống hoặc quản trị viên nâng hạn mức. Trò chuyện vẫn hoạt động bình thường.",
  renamed: "Đã đổi tên.",
  scheduleSaved: "Đã lưu lịch mới.",
  destSaved: "Từ lần chạy tới, nó sẽ đăng ở đó với công thức mới.",
  rename: "Đổi tên",
  changeSchedule: "Đổi lịch",
  changeDestination: "Đổi nơi đăng",
  name: "Tên",
  whenCron: "Thời gian (cron)",
  cronHelpEdit: "Năm trường cron, theo múi giờ của nó ({tz}), như lúc tạo.",
  savedSchedule: "Đã lưu. Lần chạy tới sẽ tạo công thức mới.",
  savedEvent: "Đã lưu. Sự kiện tiếp theo sẽ được viết theo cách mới.",
  repinning: "Đang ghim lại: một lần chạy mẫu sẽ đăng ngay và trở thành công thức mới.",
  runningNow: "Đang chạy. Lát nữa nó sẽ đăng vào {dest}.",
  whatItDoes: "Việc cần làm",
  instruction: "Hướng dẫn",
  instructionHelp: "Viết bằng lời thường. Vantage sẽ biến chúng thành công thức bên dưới.",
  whenAndWhere: "Thời gian và nơi đăng",
  runsWith: "Chạy với quyền",
  cost: "Chi phí",
  recipe: "Công thức",
  noRecipeForEvents:
    "Mỗi sự kiện được viết ngay khi xảy ra, từ chính dữ kiện của sự kiện đó: không có công thức để ghim.",
  recipeStale:
    "Công thức đã ngừng hoạt động; các lần chạy gần đây đã chạy đầy đủ. Ghim lại để tiết kiệm chi phí như trước.",
  pinnedOn: "Đã ghim sau lần chạy mẫu ngày {date}, nên lần chạy nào cũng nhanh và giống nhau.",
  pinned: "Đã ghim, nên lần chạy nào cũng nhanh và giống nhau.",
  noRecipe:
    "Chưa có công thức: lần chạy tới sẽ chạy đầy đủ, và cách nó làm sẽ trở thành công thức.",
  repin: "Ghim lại",
  learned: "Đã học từ phản hồi",
  learnedNone:
    "Chưa có gì. Bấm 👎 kèm ghi chú trên một bài đăng của nó để nó rút kinh nghiệm cho lần chạy tới.",
  lessonUndone: "Đã hoàn tác. Lần chạy tới sẽ không dùng bài học đó.",
  recentRuns: "Các lần chạy gần đây",
  noRunsYetPeriod: "Chưa chạy lần nào.",
  sampleRun: "Lần chạy mẫu, {date}",
  guardRailsTitle: "Giới hạn an toàn",
  runNow: "Chạy ngay",
  viewOnly: "Bạn xem được tác vụ tự động này; chỉ {who} mới thay đổi được.",
  sayWhichProject: "Hãy cho biết dự án cần theo dõi.",
  sayWhichRepo: "Hãy cho biết repository cần theo dõi.",
  fillTheForm: "Hãy đặt tên, mô tả việc cần làm và thời gian chạy.",
  setUpSample: "Đã tạo “{name}”. Một lần chạy mẫu sẽ đăng ngay.",
  setUpEvent: "Đã tạo “{name}”. Nó sẽ kiểm tra mỗi 5 phút.",
  namePlaceholder: "Tiến độ HoaVN thứ Hai",
  whatPlaceholder:
    "Đăng tiến độ HoaVN tuần trước: ticket đã mở, đã chuyển và đã đóng, PR đã merge, và các bug bị mở lại.",
  whatHelpNew: "Viết bằng lời thường. Vantage sẽ biến chúng thành công thức sau lần chạy mẫu.",
  runs: "Chạy",
  onSchedule: "Theo lịch",
  onEvent: "Khi có sự kiện",
  repeats: "Lặp lại",
  day: "Ngày",
  minute: "Phút",
  at: "Lúc",
  cronHelpNew:
    "Giờ công ty ({tz}). Chọn ở trên, hoặc nhập năm trường cron. Tối đa một lần mỗi giờ.",
  source: "Nguồn",
  whatHappens: "Sự kiện",
  project: "Dự án",
  repository: "Repository",
  toStatus: "Sang trạng thái",
  toStatusHelp: "Để trống để theo dõi mọi thay đổi trạng thái.",
  assignedTo: "Giao cho",
  anyone: "Bất kỳ ai",
  reviewer: "Người review",
  eventHelp: "Kiểm tra mỗi 5 phút. Chỉ tính các thay đổi sau khi tạo.",
  where: "Nơi đăng",
  emailMe: "Gửi email cho tôi",
  channels: "Kênh",
  readsOnly: "Nó chỉ đọc những gì cả người sở hữu lẫn nơi nó đăng vào đều được xem.",
  creating: "Đang tạo…",
  create: "Tạo",
  samplePostsNow: "Một bản mẫu sẽ đăng ngay.",
  remindersDidntLoad: "Không tải được lời nhắc của bạn",
  noReminders: "Không có lời nhắc sắp tới",
  noRemindersBody:
    "Hỏi Vantage trong cuộc trò chuyện: “nhắc tôi 4 giờ chiều thứ Sáu xem lại ghi chú phát hành”.",
  yourReminders: "Lời nhắc của bạn",
  reminderCancelled: "Đã hủy lời nhắc: {text}",
  couldntCancel: "Không hủy được.",
  movedTo: "Đã dời sang {when}.",
  newTime: "Thời gian mới",
  keepTime: "Giữ thời gian hiện tại",
  changeTime: "Đổi thời gian",
  cancelReminder: "Hủy lời nhắc",
};
